import { CompareIcon } from './CompareIcon';

export interface PortfolioCompareCardButtonProps {
  selected: boolean;
  onToggle: () => void;
  disabled?: boolean;
}

const PortfolioCompareCardButton = ({
  selected,
  onToggle,
  disabled = false,
}: PortfolioCompareCardButtonProps) => (
  <button
    type="button"
    className={[
      'absolute right-[14px] top-0 z-[6] inline-flex -translate-y-1/2 cursor-pointer select-none items-center gap-[5px] rounded-full border px-[10px] py-[5px] text-xs font-semibold leading-none backdrop-blur-[8px] shadow-[0_4px_14px_rgba(0,0,0,0.32),0_0_0_1px_rgba(0,0,0,0.15)] transition-[background,border-color,color,box-shadow,transform] duration-150 disabled:cursor-not-allowed disabled:opacity-45 enabled:hover:-translate-y-[calc(50%+1px)] enabled:hover:border-primary/45 enabled:hover:bg-primary/18 enabled:hover:text-[#8bd6f1] enabled:hover:shadow-[0_6px_18px_rgba(0,0,0,0.35),0_0_0_1px_rgba(37,180,224,0.2)]',
      selected
        ? 'border-primary/55 bg-primary/22 text-[#b8e8f7]'
        : 'border-[rgba(255,255,255,0.16)] bg-[rgba(8,12,22,0.94)] text-[rgba(255,255,255,0.88)]',
    ].join(' ')}
    onClick={onToggle}
    disabled={disabled}
    aria-pressed={selected}
    title={selected ? 'Remove from comparison' : 'Add to comparison'}
  >
    <CompareIcon size={14} />
    <span>{selected ? 'Selected' : 'Compare'}</span>
  </button>
);

export default PortfolioCompareCardButton;
